<ep-sub-panel blockWidth="full" panelType="transparent" [form]="form">
  <form [formGroup]="form">
    <ep-field
      columnSpan="6"
      collapseLabelArea="true"
      format="radiogroup"
      [options]="{
        codeValues: distributeOptions
      }"
      controlPath="Document.Dist_Method"
    ></ep-field>

    <ep-field label="Document Name" columnSpan="4" format="text-120" controlPath="Document.Doc_Name"></ep-field>
    <ep-field
      label="Class"
      columnSpan="2"
      format="dropdownSelector-DocClass"
      controlPath="Document.Doc_Class"
    ></ep-field>
    <ep-field
      columnSpan="6"
      label="Desc"
      format="textbox-32767"
      [options]="{ rows: 3 }"
      controlPath="Document.Doc_Desc"
    ></ep-field>
  </form>
</ep-sub-panel>
